import styled from '@emotion/styled';

import { mq } from '@hrworks/design-system/utilities';
import { LogoStyles } from '@hrworks/sui-core/Logo';

import { S as SqwLayoutStyles } from '../SqwLayout.styles';

type ContainerProps = {
  isSidebarCollapsed: boolean;
};

const Container = styled.div<ContainerProps>(({ theme, isSidebarCollapsed }) => ({
  display: 'flex',
  height: SqwLayoutStyles.componentConfig.header.height,
  paddingInline: SqwLayoutStyles.componentConfig.sidebar.horizontalPadding,
  alignItems: 'center',
  width: SqwLayoutStyles.componentConfig.sidebar.width,
  flexShrink: 0,
  position: 'relative',
  '::before': {
    content: '""',
    position: 'absolute',
    left: isSidebarCollapsed ? -SqwLayoutStyles.componentConfig.sidebar.width : 0,
    width: SqwLayoutStyles.componentConfig.sidebar.width,
    height: '100%',
    backgroundColor: theme.eclipseTier2Color.background.nav.default,
    zIndex: -1,
    boxShadow: `1px 0 0 0 ${isSidebarCollapsed ? 'transparent' : theme.eclipseTier2Color.border.nav.subtle}`,
  },

  [mq.conditionalTransition]: {
    '::before': {
      transition: `left ${theme.marko.variables.animationDuration.long}, box-shadow ${theme.marko.variables.animationDuration.long}`,
    },
  },

  [mq.isSmallDevice]: {
    '::before': {
      left: 0,
      boxShadow: 'none',
    },
  },
}));

const ToggleWrapper = styled.div(({ theme }) => ({
  flex: 1,
  display: 'flex',
  paddingRight: theme.marko.variables.spacing.distance.medium,
}));

const LogoWrapper = styled.div({
  height: '100%',
  overflow: 'hidden',
  [LogoStyles.sel.Logo]: {
    maxWidth: SqwLayoutStyles.componentConfig.header.logoWidth,
  },
});

const Spacer = styled.div({
  flex: 1,
});

export const S = {
  Container,
  ToggleWrapper,
  LogoWrapper,
  Spacer,
} as const;
